import pullLog from '../../../api/pullLogs/pullLog'

const pullLogs = new pullLog();

const pullLogModule = {
  namespaced: true,
  state: {
    items: [],
    total: 0,
    load: false,
    loadPull: false,
    conec_name: 'test',
    pullStatus: {},
    pullProgress: {},
    pullLogDetails: [],
    pullLogSummary: null,   // pull_log object من الـ Details endpoint
    pullIds: {}, // Track pull_id per connection (keyed by connection name)
  },
  getters: {
    items(state) { return state.items; },
    total(state) { return state.total; },
    load(state) { return state.load; },
    loadPull(state) { return state.loadPull; },
    conec_name(state) { return state.conec_name; },
    pullStatus(state) { return state.pullStatus; },
    pullProgress(state) { return state.pullProgress; },
    pullLogDetails(state) { return state.pullLogDetails; },
    pullLogSummary(state) { return state.pullLogSummary; },
    pullIds(state) { return state.pullIds; },
  },
  mutations: {
    SET_ITEMS: (state, items) => { state.items = items; },
    SET_TOTAL_ITEMS: (state, total) => { state.total = total; },
    SET_ITEMS_LOAD: (state, load) => { state.load = load; },
    SET_ITEM: (state, item) => { state.item = item; },
    SET_LOADPULL(state, loadPull) { state.loadPull = loadPull; },
    SET_LOOKUPS(state, lookups) { state.lookups = lookups; },
    SET_CONEC_NAME(state, conec_name) { state.conec_name = conec_name; },
    SET_PULL_STATUS(state, payload) {
      state.pullStatus = { ...state.pullStatus, ...payload };
    },
    SET_PULL_PROGRESS(state, payload) {
      state.pullProgress = { ...state.pullProgress, ...payload };
    },
    SET_PULL_LOG_DETAILS(state, details) {
      state.pullLogDetails = details;
    },
    SET_PULL_LOG_SUMMARY(state, summary) {
      state.pullLogSummary = summary;
    },
    SET_PULL_ID(state, { connection, pull_id }) {
      state.pullIds = { ...state.pullIds, [connection]: pull_id };
    },
  },
  actions: {
    /**
     * POST /api/pullLogs — جيب قائمة الفروع مع status و progress
     */
    pullLogs({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('SET_ITEMS_LOAD', true);
        pullLogs.list(payload.query)
          .then(response => {
            commit('SET_ITEMS', response.data);
            commit('SET_TOTAL_ITEMS', response.meta.count);
            if (response.meta.lookup) {
              commit('SET_LOOKUPS', response.meta.lookup);
            }
            commit('SET_ITEMS_LOAD', false);
            resolve(response);
          })
          .catch(error => {
            commit('SET_ITEMS_LOAD', false);
            reject(error);
          });
      });
    },

    /**
     * POST /api/pullLogs/pull/{connection_name}
     * يبدأ Pull جديد — الـ response بيرجع فوراً بـ pull_id + status: pending
     * لو 409: pull شغال بالفعل → نـresolve مع already_in_progress: true
     * لو 503: Oracle error → نـreject بدون ما نغير الـ badge
     */
    pullData({ commit }, { id, date }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADPULL', true);
        commit('SET_CONEC_NAME', id);
        // نحط pending في الـ UI فوراً
        commit('SET_PULL_STATUS', { [id]: { status: 'pending', is_pulling: true } });
        commit('SET_PULL_PROGRESS', { [id]: 0 });

        pullLogs.pullData({ id, date })
          .then(response => {
            const data = response;
            commit('SET_LOADPULL', false);
            commit('SET_CONEC_NAME', 'test');
            // خزّن الـ pull_id عشان نفتح الـ Details Modal
            if (data.pull_id) {
              commit('SET_PULL_ID', { connection: id, pull_id: data.pull_id });
            }
            resolve(data);
          })
          .catch(error => {
            commit('SET_LOADPULL', false);
            commit('SET_CONEC_NAME', 'test');

            // 409: Pull شغال بالفعل → نعرض progress وندي الـ UI يبدأ polling
            if (error.response && error.response.status === 409) {
              const data = error.response.data;
              commit('SET_PULL_STATUS', {
                [id]: { status: data.status || 'processing', is_pulling: true }
              });
              commit('SET_PULL_PROGRESS', { [id]: data.progress || 0 });
              if (data.pull_id) {
                commit('SET_PULL_ID', { connection: id, pull_id: data.pull_id });
              }
              // نرجّع resolve عشان الـ UI يبدأ polling بدل ما يعرض error
              resolve({ ...data, already_in_progress: true });
              return;
            }

            // 503 أو أي error آخر: نعرض toast بس ومنغيرش الـ badge
            // نرجّع الـ status للـ state اللي كانه قبل ما ندوس Pull
            commit('SET_PULL_STATUS', { [id]: { status: null, is_pulling: false } });
            commit('SET_PULL_PROGRESS', { [id]: 0 });
            reject(error);
          });
      });
    },

    /**
     * GET /api/pullLogs/status/{connection_name}
     * يجيب الـ progress وحالة الـ pull الحالي
     * ⚠️ بيرجع pull_id كمان — هنخزنه عشان نفتح الـ Details Modal
     */
    fetchPullStatus({ commit }, connection_name) {
      return new Promise((resolve, reject) => {
        pullLogs.getPullStatus(connection_name)
          .then(response => {
            const data = response;
            commit('SET_PULL_STATUS', {
              [connection_name]: {
                status: data.status,
                is_pulling: data.is_pulling,
                cases_no: data.cases_no,
                branch_name: data.branch_name,
                start_date: data.start_date,
                end_date: data.end_date,
              }
            });
            commit('SET_PULL_PROGRESS', { [connection_name]: data.progress || 0 });
            if (data.pull_id) {
              commit('SET_PULL_ID', { connection: connection_name, pull_id: data.pull_id });
            }
            resolve(data);
          })
          .catch(error => {
            // 404: Connection مش موجودة — وقّف الـ Polling بهدوء
            if (error.response && error.response.status === 404) {
              commit('SET_PULL_STATUS', {
                [connection_name]: { status: 'failed', is_pulling: false }
              });
              // resolve بـ failed عشان pollActiveConnections يوقف الـ polling
              resolve({ status: 'failed', is_pulling: false });
              return;
            }
            reject(error);
          });
      });
    },

    /**
     * GET /api/pullLogs/details/{pull_log_id}
     * ⚠️ الـ pull_log_id هو نفسه الـ id في الـ List response (item.id)
     */
    fetchPullLogs({ commit }, pull_log_id) {
      return new Promise((resolve, reject) => {
        pullLogs.getPullLogDetails(pull_log_id)
          .then(response => {
            const data = response;
            // حفظ الـ details array (log messages)
            if (data.details) {
              commit('SET_PULL_LOG_DETAILS', data.details);
            }
            // حفظ الـ pull_log summary (branch info, stats, status)
            if (data.pull_log) {
              commit('SET_PULL_LOG_SUMMARY', data.pull_log);
            }
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },
};

export default pullLogModule;